import script from "./TopMenuBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TopMenuBox.vue?vue&type=script&setup=true&lang=js"

import "./TopMenuBox.vue?vue&type=style&index=0&id=1ba5a0d1&scoped=true&lang=css"
/* custom blocks */
import block0 from "./TopMenuBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/tml/work/WP-plugins/wpaprsdb/wpaprsdb/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ba5a0d1"]])

export default __exports__